import React from 'react';

// Small pill badge (e.g. cart count). Content passed as children.
export default function Badge({ className = '', children, ...rest }) {
  return (
    <span className={`ss-badge ${className}`.trim()} {...rest}>
      {children}
    </span>
  );
}
